// extracted by mini-css-extract-plugin
export var details = "_gd-0";
export var inspectorPopover = "_gd-1";